import { Link } from 'react-router-dom';
import { services } from '../../../mocks/services';

export default function ServiceCards() {
  return (
    <section id="hizmetler" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-3 block">Danışmanlık Alanları</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light text-warm-dark mb-4">Size en uygun alanı seçin</h2>
          <p className="text-warm-mid text-sm md:text-base max-w-lg mx-auto leading-relaxed">
            Her ilişki kendine özgüdür. Hangi alanda destek almak istediğinizi seçin, size özel bir süreç tasarlayalım.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, i) => (
            <Link
              key={service.id}
              to={service.slug}
              className="group relative bg-cream rounded-2xl p-7 md:p-8 hover:bg-warm-dark transition-all duration-500 cursor-pointer border border-cream-deeper hover:border-warm-dark overflow-hidden"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              {/* Background glow */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500"
                style={{ background: `radial-gradient(circle at 30% 30%, #C4973E, transparent 60%)` }} />

              <div className="relative">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-5 transition-colors duration-300"
                  style={{ backgroundColor: service.color }}>
                  <i className={`${service.icon} text-warm-mid group-hover:text-gold text-xl transition-colors`} />
                </div>
                <h3 className="font-serif text-xl font-medium text-warm-dark group-hover:text-cream-dark mb-2 transition-colors">{service.title}</h3>
                <p className="text-sm text-warm-light group-hover:text-warm-pale/70 leading-relaxed mb-6 transition-colors">{service.shortDesc}</p>
                <div className="flex items-center gap-2 text-xs font-medium text-gold group-hover:text-gold-light transition-colors">
                  <span>Detayları incele</span>
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}